import React from "react";
import { Link } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
type PageShellProps = {
  title: string;
  intro: string;
};
export function PageShell({
  title,
  intro
}: PageShellProps) {
  return <div className="min-h-screen w-full bg-cream" data-id="element-172" data-mp="33kiu2or8v8u2">
      <div className="mx-auto max-w-[1320px] px-3 pt-4 md:px-10 md:pt-6" data-id="element-173" data-mp="38h99d9v860ef">
        <Header data-id="element-174" data-mp="1za09ipz9ac" />
      </div>
      <main className="mx-auto max-w-[1320px] px-5 py-24 md:px-10 md:py-32" data-id="element-175" data-mp="1pighi10u2j">
        <h1 className="max-w-3xl font-serif text-5xl leading-[1.05] md:text-7xl" data-id="element-176" data-mp="50sdra87flxb">{title}</h1>
        <p className="mt-6 max-w-xl text-lg leading-relaxed text-navy-soft" data-id="element-177" data-mp="3m979wwavenyz">{intro}</p>
        <p className="mt-10 inline-block rounded-full bg-sand px-5 py-2 text-sm" data-id="element-178" data-mp="3mbjp51p8uk8c">Page en cours de rédaction</p>
        <div className="mt-10" data-id="element-179" data-mp="2au0iezcgfz51">
          <Link to="/" className="font-semibold underline underline-offset-4" data-id="element-180" data-mp="2atqxvra6ik6q">Retour à l'accueil</Link>
        </div>
      </main>
      <Footer data-id="element-181" data-mp="2fuoew0jgd86n" />
    </div>;
}